import { render, staticRenderFns } from "./BotaoGerarQRCode.vue?vue&type=template&id=2006254f&scoped=true"
import script from "./BotaoGerarQRCode.vue?vue&type=script&lang=js"
export * from "./BotaoGerarQRCode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2006254f",
  null
  
)

export default component.exports